import { OrganizationType } from '@interfaces/organizationType.interface';

import api from './';

export const { useGetOrganizationTypesQuery } = api.injectEndpoints({
  endpoints: (build) => ({
    getOrganizationTypes: build.query<OrganizationType[], void>({
      query: () => ({ url: 'organization-type' }),
    }),
  }),
});
